import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

/**
 * Browser translators (Google Translate, Edge, Safari) wrap text nodes in
 * <font> tags. When React later updates that text it can throw
 * "Failed to execute 'removeChild'/'insertBefore'". These guards make those
 * operations safe so the page keeps working while translated.
 */
function guardAgainstTranslatorCrashes() {
  if (typeof Node !== "function" || !Node.prototype) return;
  const proto = Node.prototype as Node & {
    __ff365Guarded?: boolean;
  };
  if (proto.__ff365Guarded) return;
  proto.__ff365Guarded = true;
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) child.parentNode.removeChild(child);
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
guardAgainstTranslatorCrashes();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-407" data-mp="1od3cmiruun03" />);
}